import React from 'react';

const Home: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-[#F8F4E3] via-[#F2E8CF] to-[#E8DFC5] p-8">
      <h1 className="text-6xl font-['Italianno',_cursive] mb-8 text-[#2C5F2D]">Easy Seasonal Food</h1>
      <div className="max-w-xl w-full text-center">
        <p className="text-2xl font-['Merriweather',_serif] text-[#4A3728] mb-4 leading-relaxed">
          Thank you for taking part in our Farmer's Market Experiment!
        </p>
        <p className="text-lg font-['Open_Sans',_sans-serif] text-[#4A3728] mb-10 opacity-80">
          To learn more about our work with local food, visit us at Resilient Foodways.
        </p>
        <a
          href="https://resilientfoodways.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-10 py-4 bg-[#2C5F2D] text-[#F8F4E3] rounded-lg shadow-lg hover:bg-[#234C24] transition-all duration-300 transform hover:scale-105 font-['Open_Sans',_sans-serif] font-semibold text-lg"
        >
          resilientfoodways.com
        </a>
      </div>
    </div>
  );
};

export default Home;
